export default "__VITE_ASSET__v3yzttfk__"